/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function($) {
    
  function initFullpg() {

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  
            $('#fullpage').fullpage({
                hybrid: true,
                fitToSection: false,
                normalScrollElementTouchThreshold: 3,
                responsiveWidth: '1366'
            });  
    }
  
    else {

        $('#fullpage').fullpage({
            hybrid: true,
            fitToSection: false,
            normalScrollElementTouchThreshold: 3,
            responsiveWidth: '992'
        });

    }
      
  }
    
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
          
        $(document).ready(function() {
            $('.loading-animation').addClass('active');  
        });
          
        $( window ).load(function() {
            setTimeout(function() {
                $('.loading-overlay').removeClass('is-entering');
                $('.loading-animation').removeClass('active');  
            }, 1500); 
        });
          
          
        // Scroll Reveal
        window.sr = ScrollReveal({
          //reset: true,
          opacity: 0,
          scale: 1,
          // duration: 1000,
          distance: '100px',
          mobile: false,
          // easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
          origin: 'bottom',
          viewFactor: 0.6
        });
        // sr.reveal('.fadein');
        sr.reveal('.leader', {
          duration: 800,
          easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
          viewFactor: 0.6
        }, 100);
        sr.reveal('.fadein', {
          duration: 1000,
          reset: false,
          viewFactor: 0.7,
          origin: 'right',
        });
        $('.hamburger-menu').on('click', function() {
          $('.bar').toggleClass('animate');
          $('.nav-primary').toggleClass('active');
        });
        $('.scrollanchor, .smoothscroll').click(function() {
          $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
          }, 600);
          return false;
        });
        $(function() {
          'use strict';
          var $container = $('#main');
          var options = {
              prefetch: true,
              cacheLength: 2,
              onBefore: function($currentTarget, $container) {
                // console.log("start first");
                                 
              },
              onStart: {
                duration: 500, // Duration of our animation
                render: function($container) {
                  // Add your CSS animation reversing class
                  $container.addClass('is-exiting');
                    
                    setTimeout(function() {
                        $('.loading-overlay').addClass('is-entering');
                    }, 100);

                  // Restart your animation
                  smoothState.restartCSSAnimations();
                  console.log("second");
                  if ($("html").hasClass("fp-enabled")) {
                        setTimeout(function() {
                        $.fn.fullpage.destroy('all');
                        }, 250);  
                  }
                }
              },
                onProgress: {
                // How long this animation takes
                    duration: 2000,
                // A function that dictates the animations that take place
                    render: function ($container) {
                        
                        $('.loading-animation').addClass('active');  
                        
                    }
                },

              onReady: {
                duration: 500,
                render: function($container, $newContent) {
                  // Remove your CSS animation reversing class
                  $container.removeClass('is-exiting');
                    
                    
                  // Inject the new content
                  $container.html($newContent);
                  console.log("third");
                }
              },
              onAfter: function() {
                console.log("fourth");
                  
                    setTimeout(function() {
                    $('.loading-overlay').removeClass('is-entering');  
                    $('.loading-animation').removeClass('active');
                    }, 500);
                   
                  
              }
            },
            smoothState = $('#main').smoothState(options).data('smoothState');
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

          
          
        $(document).ready(function() {
        var scene = document.getElementById('intro-parallax');
        var parallax = new Parallax(scene);
        var tilt = 1.6, 
        curTiltX = 0,
        curTiltY = 0;
        window.addEventListener("mousemove",function(e){
        if((e.pageX / window.innerWidth) * 100 >= 50)
            curTiltX = (tilt / 100)*(((e.pageX - (window.innerWidth / 2)) / (window.innerWidth /2))*100) -((tilt / 100)*(((e.pageX - (window.innerWidth / 2)) / (window.innerWidth /2))*100)*2);
          else
            curTiltX = tilt - ((tilt / 100)*((e.pageX / (window.innerWidth /2))*100));

        if((e.pageY / window.innerHeight) * 100 >= 50)
            curTiltY = (tilt / 100)*(((e.pageY - (window.innerHeight / 2)) / (window.innerHeight /2))*100);
          else
            curTiltY = (tilt - ((tilt / 100)*((e.pageY / (window.innerHeight /2))*100))) -((tilt - ((tilt / 100)*((e.pageY / (window.innerHeight /2))*100)))*2);

          $('.thingy').css("transform","perspective(300px) rotateY("+curTiltX+"deg) rotateX("+curTiltY+"deg)");
        });


        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {

            // $('.thingy').hide();
            $('#intro-parallax').fadeIn();

        }

        }); 
          
          
          
          
          
          
          
        initFullpg();
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'ui': {
      init: function() {

          
        $(document).ready(function() {
        var scene = document.getElementById('intro-parallax');
        var parallax = new Parallax(scene);
        var tilt = 1.6, 
        curTiltX = 0,
        curTiltY = 0;
        window.addEventListener("mousemove",function(e){
        if((e.pageX / window.innerWidth) * 100 >= 50)
            curTiltX = (tilt / 100)*(((e.pageX - (window.innerWidth / 2)) / (window.innerWidth /2))*100) -((tilt / 100)*(((e.pageX - (window.innerWidth / 2)) / (window.innerWidth /2))*100)*2);
          else
            curTiltX = tilt - ((tilt / 100)*((e.pageX / (window.innerWidth /2))*100));

        if((e.pageY / window.innerHeight) * 100 >= 50)
            curTiltY = (tilt / 100)*(((e.pageY - (window.innerHeight / 2)) / (window.innerHeight /2))*100);
          else
            curTiltY = (tilt - ((tilt / 100)*((e.pageY / (window.innerHeight /2))*100))) -((tilt - ((tilt / 100)*((e.pageY / (window.innerHeight /2))*100)))*2);

          $('.thingy').css("transform","perspective(300px) rotateY("+curTiltX+"deg) rotateX("+curTiltY+"deg)");
        });


        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {

            // $('.thingy').hide();
            $('#intro-parallax').fadeIn();

        }

        });  
     
      }
    },

      
    // About us page, note the change from about-us to about_us.
    'experience': {
      init: function() {
          
          var headerVideoMP4 = $('.absolutely-no-play').attr('data-mp4');
		  var headerVideoWEBM = $('.absolutely-no-play').attr('data-webm');
		  var headerVideoOGV = $('.absolutely-no-play').attr('data-ogv');
          
          console.log(headerVideoMP4);
		  console.log(headerVideoWEBM);
		  console.log(headerVideoOGV);
          

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {  
        // if ($(window).width() < 1024) {  
            $('.absolutely-no-play').html('');  
        }  
        else {
            $('.absolutely-no-play').html('<video id="experienceVideo" class="video" loop muted data-autoplay><source src="'+headerVideoMP4+'" type="video/mp4" /><source src="'+headerVideoWEBM+'" type="video/webm" /><source src="'+headerVideoOGV+'" type="video/ogg" /></video>');  
        }


        var vid = document.getElementById("videoarea"); 
        var pauseButton = document.querySelector("#pause");
        var startButton = document.querySelector("#start");

        function playVid() { 
            vid.play(); 
        } 

        function pauseVid() { 
            vid.pause(); 
        }          
          

        $('.accordion-toggle').click(function(e) {
            
            $('.accordion-toggle').removeClass('active');

            if (!$(this).hasClass("collapsed")) {

                pauseVid();

            } else {
                
                var videoUrl = $(this).attr('movieurl');
                var videoUrl_webm = $(this).attr('movieurl_webm');
                var videoUrl_ogv = $(this).attr('movieurl_ogv');

                // console.log(videoUrl);
                // console.log(videoUrl_webm);
                // console.log(videoUrl_ogv);
                
                $('#crazyVideoPlayer').html('<video class="embed-responsive-item" id="videoarea" muted loop autoplay><source id="videoarea_mp4" src="'+videoUrl+'" type="video/mp4" /><source id="videoarea_webm" src="'+videoUrl_webm+'" type="video/webm" /><source id="videoarea_ogv" src="'+videoUrl_ogv+'" type="video/ogg" /></video>');
                
    
/*

        var videoUrl = $(this).attr('movieurl');
        var videoUrl_webm = $(this).attr('movieurl_webm');
        var videoUrl_ogv = $(this).attr('movieurl_ogv');

        $("#videoarea").attr({
            // "src": $(this).attr("movieurl"),
            "poster": "",
            "autoplay": "autoplay"
        });

        $("#videoarea").attr({
            "src": $(this).attr("movieurl")
        });

        $("#videoarea_webm").attr({
            "src": $(this).attr("movieurl_webm") 
        });

        $("#videoarea_ogv").attr({
            "src": $(this).attr("movieurl_ogv") 
        });

        $(".centerAlign").addClass('viewing');

        console.log(videoUrl);
        console.log(videoUrl_webm);
        console.log(videoUrl_ogv);

*/
        
                
            }

            
        });          
          
          
          
        $('#fullpage').fullpage({
            hybrid:true, 
            fitToSection: false,
            responsiveWidth: '1024',
            normalScrollElementTouchThreshold: 3,
            onLeave: function(index, nextIndex, direction){
                var leavingSection = $(this);

                //after leaving section 2
                if(index == 2 && direction =='down') {

                    pauseVid();
                    $(".centerAlign").removeClass('viewing');

                }
                else if(index == 1 && direction == 'down'){

                    playVid();
                    
                }
                else if(index == 2 && direction == 'up'){

                    pauseVid();
                    $(".centerAlign").removeClass('viewing');

                }
            }
        }); 
          

          
  

 
          
          
      }
    },
      
    'experience_2': {
      init: function() {

          
        var vid = document.getElementById("videoarea"); 
        var pauseButton = document.querySelector("#pause");
        var startButton = document.querySelector("#start");

        function playVid() { 
            vid.play(); 
        } 

        function pauseVid() { 
            vid.pause(); 
        }          


          
        $('.accordion-toggle').click(function(e) {
            
            $('.accordion-toggle').removeClass('active');

            if (!$(this).hasClass("collapsed")) {

                pauseVid();

            } else {

                var videoUrl = $(this).attr('movieurl');
                
                $("#videoarea").attr({
                    "src": $(this).attr("movieurl"),
                    "poster": "",
                    "autoplay": "autoplay"
                });
                
                $(".centerAlign").addClass('viewing');

                
                
            }

            
        });          
          
          
          
        $('#fullpage').fullpage({
            hybrid:true, 
            fitToSection: false,
            responsiveWidth: '1024',
            normalScrollElementTouchThreshold: 3,
            onLeave: function(index, nextIndex, direction){
                var leavingSection = $(this);

                //after leaving section 2
                if(index == 2 && direction =='down') {

                    pauseVid();
                    $(".centerAlign").removeClass('viewing');

                }
                else if(index == 1 && direction == 'down'){

                    playVid();
                    
                }
                else if(index == 2 && direction == 'up'){

                    pauseVid();
                    $(".centerAlign").removeClass('viewing');

                }
            }
        }); 
          

          
  

 
          
          
      }
    },
      
      
      
      
      
      
    // About us page, note the change from about-us to about_us.
    'experience_HOLD': {
      init: function() {
        console.log("experience");


        $('.experience-wrap').prepend('<div class="vidcover"></div>').hover(function() {
          $('.vidcover').css({
            'opacity': '0.4'
          })
        }, function() {
          $('.vidcover').css({
            'opacity': '0'
          })
        });
        $(window).resize(function() {
          var theWidth = $(window).width();
          var theHeight = $(window).height() + 10;
          var newWidth = (theHeight * 1.77777778);
          var newHeight = (theWidth / 1.77777778);
          if ((theWidth > 1280) && (newHeight > theHeight)) {
            $('#videoPlayer').css({
              'width': theWidth,
              'height': newHeight
            });
          }
          if ((theHeight > 720) && (newWidth > theWidth)) {
            $('#videoPlayer').css({
              'height': theHeight,
              'width': newWidth
            });
          }
          $('.vidcover').css({
            'height': theHeight,
            'width': theWidth
          });
        }).resize();
          
          
        $('.accordion-toggle').click(function(e) {
            
            $('.accordion-toggle').removeClass('active');
            
          if (!$(this).hasClass("collapsed")) {

            var iframe = document.getElementById('videoPlayer');
            var player = new Vimeo.Player(iframe);  
            player.pause(); 
            // $(".centerAlign").removeClass('viewing');
              
          } else {
            var vimeoVideoID = $(this).data('bg');
            var placehlderImg = $(this).data('img');
            $('.placeholderWrap').fadeIn().html('<div class="placeholderImg" style="background: url(' + placehlderImg + ') no-repeat center;background-size:cover;"></div>');
            $('.videoPlaying').html('<iframe id="videoPlayer" width="1280" height="720" src="http://player.vimeo.com/video/' + vimeoVideoID + '?background=1&player_id=player" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>');

            var iframe = document.getElementById('videoPlayer');
            var player = new Vimeo.Player(iframe);   
            player.play();   
            $(".centerAlign").addClass('viewing');
            $(window).resize();
    
            player.ready().then(function() {
                setTimeout(function() {
                    $('.placeholderImg').fadeOut();
                }, 1200);
            }); 

          }
        });

        $('#fullpage').fullpage({
            hybrid:true, 
            fitToSection: false,
            responsiveWidth: '1024',
            normalScrollElementTouchThreshold: 3,
            onLeave: function(index, nextIndex, direction){
                var leavingSection = $(this);

                //after leaving section 2
                if(index == 2 && direction =='down') {

                    var iframe = document.getElementById('videoPlayer');
                    var player = new Vimeo.Player(iframe);  
                    player.pause(); 
                    $(".centerAlign").removeClass('viewing');

                }
                else if(index == 1 && direction == 'down'){

                    var iframe = document.getElementById('videoPlayer');
                    var player = new Vimeo.Player(iframe);   
                    player.play();  
                    
                    player.ready().then(function() {
                        setTimeout(function() {
                            $('.placeholderImg').fadeOut();
                        }, 500);
                    }); 
                }
                else if(index == 2 && direction == 'up'){

                    var iframe = document.getElementById('videoPlayer');
                    var player = new Vimeo.Player(iframe);  
                    player.pause(); 
                    $(".centerAlign").removeClass('viewing');

                }
            }
        });
          
          
      }
    },
    // Story
    'story': {
      init: function() {
  
        var myVideo = document.getElementById("ourStoryVid"); 
          
        function playPause() { 
            if (myVideo.paused) {
                myVideo.play(); 
                $('#playStoryVid').html('<i class="ion-ios-pause"></i>');
            } else {
                myVideo.pause(); 
                $('#playStoryVid').html('<i class="ion-ios-play"></i>');
            } 
        } 

        $('#playStoryVid').click(function(){
            playPause(); 
        }); 



        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            
            document.getElementById("ourStoryVid").setAttribute('autoplay', true);
   
        }

        else {

        }

          

          
          
          
          
          
          
          
        $('#fullpage').fullpage({
            hybrid: true,
            fitToSection: false,
            responsiveWidth: '1024',
            normalScrollElementTouchThreshold: 3, 
            onLeave: function(index, nextIndex, direction){
            // After Leaving Section 1
            var leavingSection = $(this);
                if(index == 1 && direction == 'down'){

                }
            }
        }); 
          
          
      }
    },
    // Leadership
    'leadership': {
      init: function() {
        initFullpg();
        // console.log("leadership");
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');
      // Fire page-specific init JS, and then finalize JS
      var body_class = document.getElementsByClassName("body_class");
      //console.log (body_class[0].className);
      $.each(body_class[0].className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
/* jshint ignore:end */
// Code here will be linted with JSHint.